import { render, staticRenderFns } from "./ReferralTests.vue?vue&type=template&id=7406c92e"
import script from "./ReferralTests.vue?vue&type=script&lang=js"
export * from "./ReferralTests.vue?vue&type=script&lang=js"
import style0 from "./ReferralTests.vue?vue&type=style&index=0&id=7406c92e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports